"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TSGameMatch = void 0;
const KHRandom_1 = require("./KH/KHRandom");
const TSBlock_1 = require("./TSBlock");
const TSColors_1 = require("./TSColors");
class TSGameMatch {
    constructor(validator) {
        this.movingBlocks = [];
        this.validator = validator;
    }
    onStart(scene) {
        this.gameInterface.addBlock(new TSBlock_1.TSBlock(scene, TSColors_1.TSBlockType.DarkGray, TSBlock_1.TSBlockAttribute.Blocks), 0, 3, false);
        this.gameInterface.addBlock(new TSBlock_1.TSBlock(scene, TSColors_1.TSBlockType.DarkGray, TSBlock_1.TSBlockAttribute.Blocks), 0, 4, false);
        this.gameInterface.addBlock(new TSBlock_1.TSBlock(scene, TSColors_1.TSBlockType.DarkGray, TSBlock_1.TSBlockAttribute.Blocks), 0, 5, false);
        this.gameInterface.addBlock(new TSBlock_1.TSBlock(scene, TSColors_1.TSBlockType.DarkGray, TSBlock_1.TSBlockAttribute.Blocks), 5, 3, false);
        this.gameInterface.addBlock(new TSBlock_1.TSBlock(scene, TSColors_1.TSBlockType.DarkGray, TSBlock_1.TSBlockAttribute.Blocks), 5, 4, false);
        this.gameInterface.addBlock(new TSBlock_1.TSBlock(scene, TSColors_1.TSBlockType.DarkGray, TSBlock_1.TSBlockAttribute.Blocks), 5, 5, false);
        const pieces = [];
        for (let i = 0; i < 17; i++) {
            pieces.push(new TSBlock_1.TSBlock(scene, TSGameMatch.colorOrder[i % TSGameMatch.colorOrder.length], TSBlock_1.TSBlockAttribute.Blocks));
        }
        new KHRandom_1.KHRandomGeneral().shuffleArray(pieces);
        for (let i = 0; i < pieces.length; i++) {
            if (i < 6)
                this.gameInterface.addBlock(pieces[i], i, 0, true);
            else if (i < 12)
                this.gameInterface.addBlock(pieces[i], i % 6, 1, true);
            else if (i < 14)
                this.gameInterface.addBlock(pieces[i], i % 12, 2, true);
            else if (i < 16)
                this.gameInterface.addBlock(pieces[i], 5 - i % 14, 2, true);
            else
                this.gameInterface.addBlock(pieces[i], 2, 2, true);
        }
    }
    onWillMove(block) {
    }
    onDidMove(block, previousPos, desiredPos, successfullyMoved) {
        if (desiredPos[1] > 3 && desiredPos[1] > previousPos[1]
            && desiredPos[0] > 0 && desiredPos[0] < 5 && !successfullyMoved) {
            const valid = this.validator(block, this.getRow(block.pos.y, block), this.getCol(block.pos.x, block));
            const hasNewBlock = this.gameInterface.goToNextControlledBlock(!valid);
            const won = this.checkFull();
            if (won)
                this.gameInterface.win();
            else if (!hasNewBlock)
                this.gameInterface.lose();
        }
        else if (!successfullyMoved) {
            this.recolorBlock(block);
        }
    }
    checkFull() {
        for (let x = 1; x < 5; x++) {
            for (let y = 3; y < 6; y++) {
                if (this.gameInterface.grid.at(x, y).length < 1)
                    return false;
            }
        }
        return true;
    }
    getRow(y, blockToIgnore) {
        const arr = [];
        for (let x = 1; x < 5; x++) {
            const blocksAt = this.gameInterface.grid.at(x, y);
            if (blocksAt.length > 0 && blocksAt[0] != blockToIgnore)
                arr.push(blocksAt[0].getType());
        }
        return arr;
    }
    getCol(x, blockToIgnore) {
        const arr = [];
        for (let y = 3; y < 6; y++) {
            const blocksAt = this.gameInterface.grid.at(x, y);
            if (blocksAt.length > 0 && blocksAt[0] != blockToIgnore)
                arr.push(blocksAt[0].getType());
        }
        return arr;
    }
    recolorBlock(block) {
        let idx = TSGameMatch.colorOrder.indexOf(block.getType());
        if (idx === undefined) {
            console.log("Unexpected color ${block.getType()}");
            idx = 0;
        }
        const newType = TSGameMatch.colorOrder[(idx + 1) % TSGameMatch.colorOrder.length];
        block.setType(newType);
    }
    addMovingBlock(block) {
        this.gameInterface.addBlock(block, block.path[0][0], block.path[0][1], false);
        this.movingBlocks.push(block);
    }
    static SameCol() {
        return new TSGameMatch((blockToPlace, row, col) => {
            for (let blockType of col) {
                if (blockToPlace.getType() != blockType)
                    return false;
            }
            return true;
        });
    }
    static SameRow() {
        return new TSGameMatch((blockToPlace, row, col) => {
            for (let blockType of row) {
                if (blockToPlace.getType() != blockType)
                    return false;
            }
            return true;
        });
    }
    static DifferentCol() {
        return new TSGameMatch((blockToPlace, row, col) => {
            for (let blockType of col) {
                if (blockToPlace.getType() == blockType)
                    return false;
            }
            return true;
        });
    }
    static DifferentRow() {
        return new TSGameMatch((blockToPlace, row, col) => {
            for (let blockType of row) {
                if (blockToPlace.getType() == blockType)
                    return false;
            }
            return true;
        });
    }
    static DifferentAll() {
        return new TSGameMatch((blockToPlace, row, col) => {
            for (let blockType of row) {
                if (blockToPlace.getType() == blockType)
                    return false;
            }
            for (let blockType of col) {
                if (blockToPlace.getType() == blockType)
                    return false;
            }
            return true;
        });
    }
    static Rainbow() {
        return new TSGameMatch((blockToPlace, row, col) => {
            const idx = blockToPlace.pos.x - 1;
            const expectedType = TSGameMatch.colorOrder[idx % TSGameMatch.colorOrder.length];
            return blockToPlace.getType() == expectedType;
        });
    }
}
exports.TSGameMatch = TSGameMatch;
TSGameMatch.colorOrder = [TSColors_1.TSBlockType.Red, TSColors_1.TSBlockType.Yellow, TSColors_1.TSBlockType.Green, TSColors_1.TSBlockType.Blue];
